import * as React from 'react';
import { useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Logo from '../components/Logo'

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { supabase } from '../supabaseClient';

import { ThemeClient } from '../contexts/Theme'
import { useHistory } from 'react-router-dom';

import Navbar from '../Navbar'

import { generateHash } from '../utils'
import { useCode } from '../contexts/Code';

export default function Register() {
    const history = useHistory();
    const {code} = useCode()

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorOpen, setErrorOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            var { data, error } = await supabase
                .from('companies')
                .select('*')

            var company = data.find(company => company.id == code)

            if (!company) {
                setErrorMessage('Por favor, ingresa el codigo de la compañía.');
                setErrorOpen(true);
                return;
            }

            var { data, error } = await supabase.auth.signUp({
                email: email,
                password: password,
                email_confirm: true
            })

            if (error) {
                setErrorMessage('Error al registrar el usuario. Por favor, intenta nuevamente.');
                setErrorOpen(true);
                console.log('Error registering user:', error.message);
                return;
            }

            console.log(data)

            var {data, error} = await supabase
               .from('users')
               .update({
                    name: name,
                    company: company.id,
                })
               .eq('id', data.user.id)

            console.log(data,error)

            // login this user
            var { user, error } = await supabase.auth.signInWithPassword({
                email: email,
                password: password
            })

            // Redirect to the desired page after successful registration
            history.push("/avatar");
            console.log('redirected')
        } catch (error) {
            console.error('Error registering user:', error.message);
        }
    };

    const handleCloseError = () => {
        setErrorOpen(false);
    };

    return (
        <ThemeClient>
            <Navbar title={'Registrarse'} />
  
            <Snackbar open={errorOpen} autoHideDuration={6000} onClose={handleCloseError}>
                <MuiAlert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                    {errorMessage}
                </MuiAlert>
            </Snackbar>

            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Logo
                        style={{
                        height: 'auto',
                        maxWidth: '100%',
                        marginTop: '2rem',
                        marginBottom: '2rem',
                        }}
                    />
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="name"
                            label="Nombre"
                            name="name"
                            autoComplete="name"
                            autoFocus
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Correo electrónico"
                            name="email"
                            autoComplete="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Contraseña"
                            type="password"
                            id="password"
                            autoComplete="new-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Registrarse
                        </Button>
                    </Box>

                    <Grid container>
                        <Grid item>
                            <Link href="/login" variant="body2">
                            ¿Tienes una cuenta? Inicia sesión
                            </Link>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </ThemeClient>
    );
}
